import { connect } from 'react-redux'
import { navigationEvent } from 'layers/navigation/store/operations'
import LinkDropdown from './component'
import { mapContentfulLinks } from './data'

const mapDispatchToProps = { navigationEvent }

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  linkMenu: mapContentfulLinks(ownProps.linkMenu),
})

export default connect(mapStateToProps, mapDispatchToProps)(LinkDropdown)
